/**
 * web/screens/menu.ts
 * Title screen — start (→ character select) and settings buttons.
 *
 * @module web/screens/menu
 */

/// <reference lib="dom" />

import type { Route } from '../router';
import { injectStyles } from '../styles';

/** Menu route factory. */
export const menuScreen: Route = (router) => {
  injectStyles();
  const screen = document.createElement('section');
  screen.className = 'sf-screen';
  screen.dataset['screen'] = 'menu';

  const title = document.createElement('h1');
  title.className = 'sf-screen-title';
  title.style.fontSize = '2.6rem';
  title.style.marginTop = '4rem';
  title.textContent = 'STARFALL COURIER';

  const subtitle = document.createElement('p');
  subtitle.className = 'sf-screen-subtitle';
  subtitle.textContent = 'Restore the sky.';

  const buttons = document.createElement('div');
  buttons.style.display = 'flex';
  buttons.style.flexDirection = 'column';
  buttons.style.gap = '0.75rem';
  buttons.style.marginTop = '2rem';

  const start = document.createElement('button');
  start.type = 'button';
  start.className = 'sf-btn sf-btn-primary';
  start.textContent = 'Start';
  start.addEventListener('click', () => router.navigate('/character-select'));

  const settings = document.createElement('button');
  settings.type = 'button';
  settings.className = 'sf-btn';
  settings.textContent = 'Settings';
  settings.addEventListener('click', () => router.navigate('/settings'));

  buttons.append(start, settings);
  screen.append(title, subtitle, buttons);

  const root = document.getElementById('app');
  root?.append(screen);
  return { destroy: () => { screen.remove(); } };
};
